<template>
  <section class="services-section">
    <div class="container">
      <div class="section-header">
        <h2 v-for="item in info.home_header1" :key="item">{{ item }}</h2>
        <p v-for="item in info.home_header1_subtitle" :key="item">{{ item }}</p>
      </div>
      <div class="services-grid">
        <div v-for="item in servicesinfo" :key="item.id" class="service-card">
          <img
            class="service-icon"
            :src="item.icon"
            :alt="item.name"
            srcset=""
          />
          <h3>{{ item.name }}</h3>
          <p>{{ item.info }}</p>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
interface FeaturedServicesType {
  id: number;
  name: string;
  icon: string;
  info: string;
}
interface titleInfoType {
  home_header1?: string[];
  home_header1_subtitle?: string[];
}

interface SectionProps {
  info: titleInfoType;
  servicesinfo?: FeaturedServicesType[];
}
withDefaults(defineProps<SectionProps>(), {});
</script>

<style scoped>
/* 内容区域通用样式 */
.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.section-header {
  text-align: center;
  margin-bottom: 50px;
}

.section-header h2 {
  font-size: 2.5rem;
  color: #1a5fb4;
  margin-bottom: 15px;
}

.section-header p {
  font-size: 1.1rem;
  color: #666;
  max-width: 600px;
  margin: 0 auto;
}

/* 特色服务 */
.services-section {
  padding: 80px 0;
  background-color: #f8f9fa;
}

.services-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 30px;
}

.service-card {
  background: white;
  padding: 30px;
  border-radius: 10px;
  text-align: center;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.05);
  transition:
    transform 0.3s,
    box-shadow 0.3s;
}

.service-card:hover {
  transform: translateY(-10px);
  box-shadow: 0 15px 30px rgba(0, 0, 0, 0.1);
}

.service-icon {
  width: 50px;
  height: 50px;
  object-fit: contain;
  margin: 0 auto;
  margin-bottom: 20px;
}

.service-card h3 {
  margin-bottom: 15px;
  color: #1a5fb4;
  font-size: 1.2rem;
}

.service-card p {
  color: #666;
  line-height: 1.6;
  font-size: 0.95rem;
}

/* 平板端适配 - 2列布局 */
@media (max-width: 1024px) {
  .services-section {
    padding: 60px 0;
  }

  .services-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 25px;
  }

  .service-card {
    padding: 25px;
  }
}

/* 移动端适配 - 单列布局 */
@media (max-width: 768px) {
  .services-section {
    padding: 50px 0;
  }

  .container {
    padding: 0 15px;
  }

  .section-header {
    margin-bottom: 40px;
  }

  .section-header h2 {
    font-size: 2rem;
  }

  .section-header p {
    font-size: 1rem;
  }

  .services-grid {
    grid-template-columns: 1fr;
    gap: 20px;
  }

  .service-card {
    padding: 20px;
  }

  .service-icon {
    width: 45px;
    height: 45px;
    margin: 0 auto;

    margin-bottom: 15px;
  }

  .service-card h3 {
    font-size: 1.1rem;
    margin-bottom: 12px;
  }

  .service-card p {
    font-size: 0.9rem;
  }
}

/* 超小屏幕适配 */
@media (max-width: 480px) {
  .services-section {
    padding: 40px 0;
  }

  .container {
    padding: 0 10px;
  }

  .section-header h2 {
    font-size: 1.6rem;
  }

  .service-card {
    padding: 18px;
  }

  .service-icon {
    width: 40px;
    height: 40px;
    margin: 0 auto;
  }
}
</style>
